module.exports = __webpack_public_path__ + "static/media/rado-1.dbe1b90f.jpeg";